import { graphql } from "babel-plugin-relay/macro";

export const CONTENT_SUBMISSION_FRAGMENT = graphql`
	fragment contentSubmissionEnd_ContentSubmissionFragment on ContentSubmission {
		learnOpportunity {
			id
			nextContentNode {
				structureDefinition {
					title
				}
				typeDefinition {
					... on LearnOpportunityELearningContentTypeDefinition {
						containedElementTypes
					}
				}
			}
			... on LearnOpportunityV2 {
				nextContentNode {
					structureDefinition {
						title
					}
				}
				root {
					id
					structureDefinition {
						title
						... on LearnOpportunityRootStructureDefinition {
							extension {
								... on LearnOpportunityRootExtensionImpl {
									configConsequences {
										rewardExpired
										showAnswerExpired
									}
								}
							}
						}
					}
					...showAnswerButtonContainer_NodeFragment
				}
			}
			typeDefinition {
				... on LearnOpportunityELearningContentTypeDefinition {
					extension {
						... on LearnContentExtensionImpl {
							configConsequences {
								percentageRequiredToPass
							}
						}
					}
					containedElementTypes
					contentNodeAdvancementResult {
						status
						... on CanNotBeRestartedAfterFailedContentNodeAdvancementResult {
							configResults {
								configType

								... on RestartIfFailedContentConfigResult {
									canBeRestarted
								}

								... on NegativeBlockPermanentlyWhenRewardedRestartIfFailedContentConfigResult {
									canBeRestarted
								}

								... on NegativeBlockTemporarilyWhenRewardedRestartIfFailedContentConfigResult {
									blockedUntil
								}
							}
						}
					}
				}
			}
			...NavigateDirectToQuestionsAdvanceTreeButton_LearnOpportunityV2Fragment
			...NavigateDirectToQuestionsAdvanceContentButton_LearnOpportunityFragment
		}
		lastUpdated
		definition {
			status

			... on FailedELearningContentSubmissionDefinition {
				relativeProgress {
					numCorrect
					numElements
					percentageCorrect
				}
			}

			... on PassedELearningContentSubmissionDefinition {
				relativeProgress {
					numCorrect
					numElements
					percentageCorrect
				}
				rewardResults {
					kind
					rewardKind
					... on PointsRewardWasPossibleResult {
						amount
						pointsPoolName
					}
					... on CertificateRewardWasPossibleResult {
						certificateName
						issuedCertificate {
							fileRef {
								url
							}
						}
					}
				}
			}
		}
		...ContentElementContainer_ContentSubmissionFragment
		...ProjectContentElementContainer_ContentSubmissionFragment
		...moduleRating_ContentSubmissionFragment
	}
`;
